import ADMIN_PERMISSIONS from '@/constants/authorization/admin-permissions'
import store from '@/store'
import { SERVER_URL } from '@/constants/config'

export default [
  {
    header: 'navigation.technical',
  },
  {
    title: 'navigation.logs-viewer',
    href: () => `${SERVER_URL}/admin/log?access_token=${store.getters['auth/token']}`,
    adminPermissions: [ADMIN_PERMISSIONS.LOG_VIEWER],
    icon: 'EyeIcon',
  },
  {
    title: 'navigation.telescope',
    href: () => `${SERVER_URL}/admin/telescope?access_token=${store.getters['auth/token']}`,
    adminPermissions: [ADMIN_PERMISSIONS.TELESCOPE],
    icon: 'SearchIcon',
  },
  {
    title: 'navigation.horizon',
    href: () => `${SERVER_URL}/horizon?access_token=${store.getters['auth/token']}`,
    adminPermissions: [ADMIN_PERMISSIONS.HORIZON],
    icon: 'SquareIcon',
  },
  {
    title: 'navigation.documentation',
    href: () => `${SERVER_URL}/admin/docs?access_token=${store.getters['auth/token']}`,
    adminPermissions: [ADMIN_PERMISSIONS.LOG_VIEWER],
    icon: 'FileTextIcon',
  },
]
